module.exports = __webpack_public_path__ + "static/necklace_of_adaptation-4bab0f0278f767ca1a0ea8c5070d9120.jpeg";